(ns minorodata.components.pipeline-editor.core
  (:require
   ["react" :as react]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.pipeline-editor.panel :as pe.panel]
   [minorodata.components.pipeline-editor.sql-generator :as pe.sql-generator]
   [minorodata.components.pipeline-editor.utils :refer [features-context]]
   [re-posh.core :as re-posh]
   [ui.page :as page]))


(defn page' [{:keys [ready? sql-generator-enabled?]}]
  (react/useEffect
   (fn []
     (dispatch [:pipeline-editor.events/init])
     #(dispatch [:pipeline-editor.events/cleanup-unmount]))
   #js [])

  [page/page-root {:class "overflow-hidden"}
   (if ready?
     [:<>
      [page/page-content {:variant :border}
       [pe.panel/panel]]
      (when sql-generator-enabled?
        [pe.sql-generator/modal])]
     [page/page-loading-screen])])

(defn page []
  (let [features               @(re-posh/subscribe [:pipeline-editor.subs/features])
        ready?                 @(re-posh/subscribe [:pipeline-editor.subs/ready?])
        sql-generator-enabled? @(re-posh/subscribe [:pipeline-editor.subs/enabled-feature "sql-generator"])]
    [:> features-context.Provider {:value #js {:features   features
                                               :read-only? false
                                               :enabled    (fn [f]
                                                             (get features (keyword f) false))}}
     [:f> page' {:ready?                  ready?
                 :sql-generator-enabled? sql-generator-enabled?}]]))
